<template>
    <div id="question-create" class="page-layout__inner w-100">
        <div class="row w-100">
            <div class="section col-md-12">
                <QuestionCreateComponent v-on:update-test="updateHeading"/>
            </div>
        </div>
    </div>
</template>
<script src="https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image"></script>
<script>
    import QuestionCreateComponent from "./Components/QuestionCreateComponent";
    import questionMixin from "./mixins/question";

    export default {
        name: "Create",
        components: {QuestionCreateComponent},
        mixins: [questionMixin],
        data() {
            return {}
        },
        created() {
            if (this.$route.query.testingId) {
                this.fetchQuestionTesting(this.$route.query.testingId).then(testing => {
                    this.$store.dispatch('test/setTest', testing);
                    this.setHeadings({
                        title: this.getTranslation('addingQuestion') + ' (' + testing.title + ', ' + testing.questionCount + ')',
                        breadcrumbs: [
                            {
                                label: this.getTranslation('testingTypes'),
                                route: {name: 'api.testing.getList'}
                            },
                            {
                                label: testing.title,
                            }
                        ],
                        toBack: {
                            label: testing.title,
                            route: {name: 'api.testing.get', params: {id: testing.id}}
                        }
                    })
                });
            }
        },
        destroyed() {
            this.$store.dispatch('test/resetCurrentTest');
        },
    }
</script>

<style scoped>

</style>
